import React, { useState, useEffect, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ReactDOM from 'react-dom'
import { trackPromise } from 'react-promise-tracker'
import axios from 'axios'
import ModalWindow from '../layout/modalwindow/ModalWindow'
import LoginStyle from './css/LoginStyle'
import App from '../../App'
import LoadingIndicator from '../layout/LoadingIndicator'
import SomethingWentWrongIndicator from '../layout/SomethingWentWrongIndicator'
import TrialExpiredForm from './forms/TrialExpiredForm'

function useLogin(props) {
  const [client, setClient] = useState({ account_id: '', user_name: '', password: '' }) // Sveltekit (new)
  const [loading, setLoading] = useState(null)
  axios.defaults.headers.common['API-KEY'] = process.env.REACT_APP_API_KEY;

  const loginClient = async () => {
    let login = null
    setLoading(<LoadingIndicator loading_message='Logging in' />)
    await trackPromise (
      axios.post(process.env.REACT_APP_API_URI + '/clients/login', client)
      .then(result => {
        login = result.data
        setLoading(null)
      })
      .catch(error => { setLoading(<SomethingWentWrongIndicator error={error} />) })
    )
    return login 
  }

  useEffect(() => {
    if (props.clientID) {
      setClient({ ...client, account_id: props.clientID.toUpperCase() })
    }
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return ({
    client: [client, setClient],
    loading: [loading, setLoading],
    loginClient
  })
}

function Login(props) {
  const login = useLogin(props)
  const accountIdRef = useRef(null)
  const userNameRef = useRef(null)
  const [error, setError] = useState(null)
  const loading = login.loading[0]
  const [client, setClient] = login.client
  const { loginClient } = login

  const onChange = (e) => {
    setClient({ ...client, [e.target.id]: e.target.value })
    setError(null)
  }

  const onKeyUp = (e) => { if (e.key === 'Enter') onClickContinue() }

  const onClickContinue = (e) => {
    const showTrialExpiredWindow = () => {
      ReactDOM.render(
        <ModalWindow
          id='mw-parent'
          width={40}
          height={40}
          header={'Trial Expired'}
          footer={null}>
            <TrialExpiredForm c_id={client.account_id}/>
        </ModalWindow>,
        document.getElementById('modal-form-container')
      )
    }
    // validate here
    loginClient()
    .then(client => {
      if (client === '') setError('Access Denied!')
      else if (client?.status.trial.active && (parseInt(client?.status.trial.number_of_days_left) <= 0)) {
        /** Show modal window */
        showTrialExpiredWindow()
      } else if (client) ReactDOM.render(<App client={client} />, document.getElementById('root'));
    })
  }

  useEffect(() => {
    if (props.clientID) userNameRef.current.focus()
    else accountIdRef.current.focus()
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <React.Fragment>
      <div className='wrapper'>
        <div className='left-container'>
          <div className='logo-container'>
            <div><img src='pos22 logo.png' alt='pos22 logo' width='280' height='100'/></div>
            {/*<div>"At your service"</div>*/}
          </div>
        </div>
        <div className='right-container'>
          <div className='login-container'>
            <div className='login-form'>
              <div className='npos-login-header'>Login</div>
              <hr className='thin-hr'/>
              <input
                id='account_id'
                ref={accountIdRef}
                type='text'
                max='24'
                min='24'
                placeholder='Account ID'
                value={client.account_id}
                onChange={onChange}
              />
              <input
                id='user_name'
                ref={userNameRef}
                type='text'
                placeholder='Username'
                value={client.user_name}
                onChange={onChange}
              />
              <input
                id='password'
                type='password'
                placeholder='Password'
                value={client.password}
                onChange={onChange}
                onKeyUp={onKeyUp}
              />
              <div className={(error) ? 'error-container' : 'hide'}>
                <FontAwesomeIcon icon='exclamation-circle' />&nbsp;
                { error }
              </div>
              <div id='loading-container'>{loading}</div>
              <button
                onClick={onClickContinue}
                className='pospro-action-btn'>
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>
      <LoginStyle />
    </React.Fragment>
  )
}

export default React.memo(Login)